import { SplitSpec } from 'features/timeSeries/experiment/types'

export type CustomRange = NonNullable<SplitSpec['custom_ranges']>[number]

/** The one writer for drawn/custom windows: unit pinned to custom, chunk
    assignments cleared (they key by chunk id, which a redraw invalidates),
    and the label format frozen. */
export const withCustomRanges = (
  split: SplitSpec,
  next: readonly CustomRange[]
): SplitSpec => ({
  ...split,
  unit: 'custom',
  assignments: {},
  custom_ranges: next.map((range) => ({
    ...range,
    label: `${range.role || 'train'} ${range.start} → ${range.end}`,
  })),
})
